const subUsersValidationFR = {
    "add": {
        "first_name": {
            "required": "Le prénom est requis"
        },
        "last_name": {
            "required": "Le nom de famille est requis"
        },
        "email": {
            "required": "L'email est requis",
            "invalid": "L'email n'est pas valide",
            "unique": "L'email est associé à un autre utilisateur"
        },
        "username": {
            "required": "Le nom d'utilisateur est requis",
            "stringCaseLower": "Le nom d'utilisateur doit être en minuscules",
            "regexp": "Le nom d'utilisateur doit se composer uniquement de lettres et de chiffres",
            "unique": "Le nom d'utilisateur est associé à un autre utilisateur",
            "invalid": "Le nom d'utilisateur n'est pas valide"
        },
        "password": {
            "required": "Le mot de passe est requis",
            "regexp": "Le mot de passe doit comporter au moins 10 caractères, dont 1 lettre majuscule et 1 caractère spécial"
        },
        "confirmPassword": {
            "required": "Veuillez confirmer le mot de passe",
            "identical": "Les valeurs du mot de passe et de la confirmation doivent correspondre"
        },
        "contract_expiry": {
            "required": "La date d'expiration du contrat est requise"
        },
        "sub_user_deal": {
            "required": "L'accord de sous-utilisateur est requis",
            "between": "L'accord de sous-utilisateur doit être entre 0 et 100"
        },
        "street_and_number": {
            "required": "La rue et le numéro de maison sont requis"
        },
        "postal_code": {
            "required": "Le code postal est requis"
        },
        "city": {
            "required": "La ville est requise"
        },
        "country": {
            "required": "Le pays est requis"
        },
        "phone": {
            "required": "Le numéro de téléphone est requis"
        }
    },
    "update": {
        "first_name": {
            "required": "Le prénom est requis"
        },
        "last_name": {
            "required": "Le nom de famille est requis"
        },
        "email": {
            "required": "L'email est requis",
            "invalid": "L'email n'est pas valide"
        },
        "username": {
            "required": "Le nom d'utilisateur est requis",
            "stringCaseLower": "Le nom d'utilisateur doit être en minuscules",
            "regexp": "Le nom d'utilisateur doit se composer uniquement de lettres et de chiffres"
        },
        "contract_expiry": {
            "required": "La date d'expiration du contrat est requise"
        },
        "sub_user_deal": {
            "required": "L'accord de sous-utilisateur est requis",
            "between": "L'accord de sous-utilisateur doit être entre 0 et 100"
        },
        "street_and_number": {
            "required": "La rue et le numéro de maison sont requis"
        },
        "postal_code": {
            "required": "Le code postal est requis"
        },
        "city": {
            "required": "La ville est requise"
        },
        "country": {
            "required": "Le pays est requis"
        },
        "phone": {
            "required": "Le numéro de téléphone est requis"
        }
    }
};

export default subUsersValidationFR;